module.exports = __webpack_public_path__ + "static/img/85109D_160117_fit.a75ef7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/85109D_160117_fit.png
// module id = RY/y
// module chunks = 0